module.exports = __webpack_public_path__ + "static/media/book_pas_cheh_bayad_kard_persian_10.5ac2407b.jpg";